import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=d5d44542&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=d5d44542&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d44542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5d44542')) {
      api.createRecord('d5d44542', component.options)
    } else {
      api.reload('d5d44542', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=d5d44542&scoped=true", function () {
      api.rerender('d5d44542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/PostageRecharge/detail.vue"
export default component.exports